"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchedWithNoResults = void 0;

var _Schema = require("../../Schema");

const searchedWithNoResults = props => {
  return {
    action: _Schema.ActionType.searchedWithNoResults,
    context_module: props.context_module,
    context_owner_id: props.context_owner_id,
    context_owner_slug: props.context_owner_slug,
    context_owner_type: props.context_owner_type,
    destination_owner_type: props.destination_owner_type,
    query: props.query
  };
};

exports.searchedWithNoResults = searchedWithNoResults;